// Code generated from payment-service/cmd/app/docs/oapi-spec.yml. DO NOT EDIT.
//
// Transport types of the trader order card, generated from the OpenAPI
// schemas the backend serves. Regenerate after changing the spec:
//
//   cd payment-service
//   go test ./internal/payment/ -run TestFrontendTransportTypesMatchOpenAPI -update
//
// The same test fails when this file and the spec disagree.

export interface PayinPart {
  amount: number;
  requisites: PayinRequisites;
}

export interface PayinPartState {
  amount: number;
  confirmedAt?: string | null;
  failureId?: string | null;
  history?: PayinPartHistory[];
  partNumber: number;
  partRevision?: number;
  receiptIds: string[];
  requisites: PayinRequisites;
}

export interface PayinPartsState {
  attemptId: string;
  parts: PayinPartState[];
  paymentId: string;
  requisitesVersion: number;
}

export interface PayinPartHistory {
  failureId: string;
  partRevision: number;
  replacedAt: string;
  requisites: PayinRequisites;
}

export interface PayinRequisites {
  bankCode?: string | null;
  bankName: string;
  cardHolder: string;
  cardNumber: string;
  iframe?: string | null;
  iframeLink?: string | null;
  kind?: "card" | "sbp" | null;
  parts?: PayinPart[];
  payment?: string | null;
  phone?: string | null;
  recipient?: string | null;
  redirect?: string | null;
}

export interface ExternalCompletion {
  action?: "completed" | "cancelled";
  attempts: number;
  confirmedAt?: string;
  maxAttempts: number;
  nextCheckAt?: string;
  proofAttempts?: number;
  proofMaxAttempts?: number;
  proofRejected?: boolean;
  reasonCode?: string;
  source: string;
  state: "pending" | "awaiting_confirmation" | "confirmed" | "attention_required";
}

export interface ExchangeClientReceipt {
  createdAt: string;
  id: string;
  sizeBytes: number;
}

export interface ExchangeSellDeposit {
  address?: string;
  confirmedAt?: string;
  deadline?: string;
  expectedAmount?: string;
  expiredAt?: string;
  network?: "trc20";
  publishedAt?: string;
  receivedAmount?: string;
  status?: "waiting_address" | "expected" | "confirmed" | "review_required";
  txHash?: string;
}

export interface ExchangeSellTerms {
  adjustedAt: string | null;
  originalRubKop: string;
  originalUsdtAmount: string;
  revision: number;
  rubKop: string;
  usdtAmount: string;
}

export interface ExchangeOrderState {
  canCompleteRub?: boolean;
  chainConfirm: boolean;
  clientMarkedPaidAt?: string;
  clientReceipts?: ExchangeClientReceipt[];
  clientRef?: string;
  deposit?: ExchangeSellDeposit;
  direction?: "sell";
  payoutAddress?: string;
  payoutAmount?: string;
  payoutConfirmedAt?: string;
  payoutConfirmedSource?: "trader" | "admin" | "chain";
  payoutNetwork?: "trc20";
  payoutSentAt?: string;
  payoutStatus?: "pending" | "confirmed" | "escalated";
  payoutTxHash?: string;
  rate?: string;
  rateQuoteId?: string;
  reviewBlocking?: boolean;
  reviewReason?: string;
  reviewRequired?: boolean;
  terms?: ExchangeSellTerms;
  watchUntil?: string;
}

export interface TraderPaymentItem {
  amount: number;
  amountReal: number | null;
  amountRemaining: number;
  appealReason: string;
  bankId: string;
  claimBlockedReason?: string;
  claimNotAfter?: string;
  claimTimeoutLocked: boolean;
  claimable: boolean;
  clientBank: string | null;
  clientCard: string | null;
  clientFio: string;
  clientPhone: string | null;
  createdAt: string;
  currency: string;
  currencyRate: string | null;
  currencyScale: number;
  exchange?: ExchangeOrderState;
  expiresAt: string | null;
  externalClosedAtSource: boolean;
  externalCompletion?: ExternalCompletion;
  externalStalled: boolean;
  externalStatus?: string;
  firstClaimedAt: string | null;
  hasAppeal: boolean;
  maxPayments: number;
  merchantDebtExceededBy?: string;
  merchantIsVip: boolean;
  merchantName: string;
  merchantOverLimit: boolean;
  merchantPortalIn?: boolean;
  merchantPortalReceiptReady?: boolean;
  merchantPortalRequisitesVersion?: number;
  orderCreatedAt: string;
  orderId: string;
  payinAmountChosenAt?: string;
  payinAmountMax?: number;
  payinAmountMin?: number;
  payinMinTransferAmount?: number;
  payinParts?: PayinPartsState;
  payinRequisites?: PayinRequisites;
  payinTransferCount?: number;
  paymentId: string | null;
  paymentsMade: number;
  prepayBlocked: boolean;
  prepayShortBy?: string;
  rateBase?: string;
  rateFixed?: string;
  rateMarkupPercent?: string;
  rateSource?: "rapira";
  receiptId: string | null;
  receiptUrl: string | null;
  remoteId: string;
  side: "in" | "out";
  status: "new" | "pending" | "success" | "cancelled" | "appeal" | "partially_filled";
  traderId: string | null;
  updatedAt: string;
  workflowKind: "standard_payin" | "standard_payout" | "external_payout" | "exchange_buy" | "exchange_sell";
}

export const ERROR_CODES = [
  "address_already_bound",
  "address_has_deposits",
  "amount_exceeds_available",
  "amount_exceeds_remaining",
  "amount_mismatch",
  "cancellation_context_changed",
  "cancellation_review_required",
  "cancellation_unavailable",
  "claim_timeout_appeal_stays_with_trader",
  "client_receipt_required",
  "client_signals_present",
  "debt_correction_key_required",
  "deposit_address_disabled",
  "deposit_address_exists",
  "exchange_direction_unsupported",
  "exchange_sell_active_order_exists",
  "exchange_sell_address_already_published",
  "exchange_sell_address_invalid",
  "exchange_sell_address_unavailable",
  "exchange_sell_amount_adjustment_forbidden",
  "exchange_sell_amount_command_conflict",
  "exchange_sell_amount_evidence_mismatch",
  "exchange_sell_amount_revision_conflict",
  "exchange_sell_close_not_allowed",
  "exchange_sell_completion_forbidden",
  "exchange_sell_deposit_required",
  "exchange_sell_not_ready",
  "exchange_sell_stage_not_found",
  "exchange_stage_not_found",
  "external_account_unconfigured",
  "external_automation_blocked",
  "external_command_rejected",
  "external_confirmation_failed",
  "external_order_closed_at_source",
  "external_order_has_paid_parts",
  "external_order_locked",
  "external_order_must_close_whole",
  "external_receipt_confirmation_ambiguous",
  "external_writes_disabled",
  "failure_evidence_required",
  "file_required",
  "idempotency_conflict",
  "invalid_address",
  "invalid_bep20_address_checksum",
  "invalid_cancellation_request",
  "invalid_currency_rate",
  "invalid_fiat_amount",
  "invalid_multipart_form",
  "invalid_requisite_last4",
  "invalid_withdrawal_minimum",
  "last_payment_must_close_order",
  "merchant_archived",
  "merchant_balance_insufficient",
  "merchant_portal_receipt_required",
  "merchant_portal_requisites_issued",
  "merchant_portal_settlement_unavailable",
  "merchant_prepay_insufficient",
  "no_payout_address",
  "nothing_to_withdraw",
  "operation_key_conflict",
  "order_cancelled",
  "order_deadline_too_close",
  "order_disputed",
  "order_has_paid_parts",
  "order_not_cancellable",
  "order_not_disputed",
  "order_not_exchange_buy",
  "order_not_in_payment",
  "order_or_evidence_not_found",
  "payin_amount_already_chosen",
  "payin_amount_out_of_range",
  "payin_amount_required",
  "payin_requisites_missing",
  "payin_requisites_unsupported",
  "payin_transfer_below_minimum",
  "payin_transfer_count_mismatch",
  "payment_already_reported",
  "payment_forbidden",
  "payment_not_found",
  "payment_not_pending",
  "payout_address_unavailable",
  "payout_already_closed",
  "payout_already_sent",
  "pending_withdrawal_request",
  "portal_in_min_transfer_invalid",
  "portal_in_range_invalid",
  "portal_in_terms_not_allowed",
  "portal_in_transfer_count_invalid",
  "portal_in_transfers_exceed_amount",
  "portal_receipt_target_changed",
  "presented_receipts_required",
  "rate_quote_conflict",
  "rate_quote_expired",
  "rate_quote_invalid",
  "rate_quote_not_found",
  "rate_source_unavailable",
  "receipt_file_extension_mismatch",
  "receipt_file_too_large",
  "receipt_file_unsupported",
  "receipt_forbidden",
  "receipt_missing",
  "receipt_not_of_payment",
  "receipt_presented_twice",
  "receipt_required",
  "requisite_mismatch",
  "rub_not_confirmed",
  "second_factor_already_enabled",
  "second_factor_enrollment_expired",
  "second_factor_invalid_code",
  "second_factor_not_enabled",
  "second_factor_required",
  "second_factor_too_many_attempts",
  "too_many_presented_receipts",
  "tx_hash_invalid",
  "withdrawal_below_minimum",
  "withdrawal_policy_changed",
  "withdrawal_policy_unavailable",
  "withdrawal_request_exists",
  "withdrawal_request_not_pending",
] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];
